// pages/ConfirmerInscriptionPage.jsx
// Confirmation d'inscription : ouverte depuis le lien de l'e-mail (/confirmer-email#jeton=..., lien envoyé par WordPress).
// Le jeton est relu à chaque changement de fragment (cf. utils/jetonFragment.js) ; chaque jeton n'est
// envoyé qu'une seule fois (le jeton ne sert qu'une fois : un second envoi donnerait « invalide »).

import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BookOpen } from 'lucide-react';
import RenvoyerConfirmation from '../components/RenvoyerConfirmation';
import { envoyerAuth, messageErreurOubli } from '../utils/authOubli';
import { useJetonFragment } from '../utils/jetonFragment';
import './AuthPages.css';

export default function ConfirmerInscriptionPage() {
  const { t } = useTranslation();
  const [statut, setStatut] = useState('enCours'); // enCours | ok | invalide | erreur
  const [erreur, setErreur] = useState('');
  const dejaEnvoyes = useRef(new Set());
  const jetonCourant = useRef('');

  const jeton = useJetonFragment(() => { setStatut('enCours'); setErreur(''); });
  jetonCourant.current = jeton;

  useEffect(() => {
    if (!jeton) { setStatut('invalide'); return; }
    if (dejaEnvoyes.current.has(jeton)) return;
    dejaEnvoyes.current.add(jeton);
    envoyerAuth('/api/auth/confirmer', { jeton }).then((rep) => {
      if (jetonCourant.current !== jeton) return; // un autre lien a été ouvert entre-temps
      if (rep.ok) return setStatut('ok');
      if (rep.code === 'JETON_INVALIDE') return setStatut('invalide');
      setErreur(rep.code === 'EMAIL_DEJA_UTILISE' ? t('auth.emailDejaUtilise') : messageErreurOubli(t, rep.code));
      setStatut('erreur');
    });
  }, [jeton]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-header">
          <BookOpen size={40} color="#4F46E5" />
          <h1>VocaVerb</h1>
          <p>{t('auth.confirmationSubtitle')}</p>
        </div>

        {statut === 'enCours' && <div className="auth-success">{t('auth.confirmationEnCours')}</div>}
        {statut === 'ok' && (
          <>
            <div className="auth-success">{t('auth.confirmationOk')}</div>
            <div className="auth-footer"><p><Link to="/login">{t('auth.seConnecter')}</Link></p></div>
          </>
        )}
        {statut === 'erreur' && <div className="auth-error">{erreur}</div>}
        {statut === 'invalide' && (
          <>
            <div className="auth-error">{t('auth.confirmationLienInvalide')}</div>
            <RenvoyerConfirmation />
          </>
        )}

        {statut !== 'ok' && <div className="auth-footer"><p><Link to="/login">{t('auth.retourConnexion')}</Link></p></div>}
      </div>
    </div>
  );
}
